module.exports = __webpack_public_path__ + "img/icon-extranet.f5f3afaf.svg";